module.exports = __webpack_public_path__ + "static/img/motrex_logo.6da9ed34.png";